export default __webpack_public_path__ + "static/media/105.aa836a34.webp";